import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BookHeart, LayoutDashboard, Book, FileText, Users, Mail, LogOut, ExternalLink, ShoppingBag, MessageCircle, Send } from "lucide-react";

const items = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "admin-nav-dashboard" },
  { to: "/admin/books", label: "Books", icon: Book, testid: "admin-nav-books" },
  { to: "/admin/posts", label: "Blog Posts", icon: FileText, testid: "admin-nav-posts" },
  { to: "/admin/purchases", label: "Purchases", icon: ShoppingBag, testid: "admin-nav-purchases" },
  { to: "/admin/comments", label: "Comments", icon: MessageCircle, testid: "admin-nav-comments" },
  { to: "/admin/newsletter", label: "Newsletter", icon: Send, testid: "admin-nav-newsletter" },
  { to: "/admin/subscribers", label: "Subscribers", icon: Users, testid: "admin-nav-subscribers" },
  { to: "/admin/contacts", label: "Messages", icon: Mail, testid: "admin-nav-contacts" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex" style={{ background: "#EEF2FF" }} data-testid="admin-layout">
      <aside className="w-64 border-r flex flex-col" style={{ background: "#E7EEFF", borderColor: "#C7B5FF" }}>
        <div className="p-6 flex items-center gap-2 border-b" style={{ borderColor: "#C7B5FF" }}>
          <span className="w-10 h-10 rounded-2xl flex items-center justify-center"
            style={{ background: "#FF6B9D", color: "#fff" }}>
            <BookHeart size={20} />
          </span>
          <div>
            <p className="font-fredoka text-lg leading-none" style={{ color: "#2D3055" }}>Studio</p>
            <p className="font-caveat text-sm" style={{ color: "#FF6B9D" }}>little wonders</p>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {items.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-2xl font-fredoka text-sm transition-colors ${
                  isActive ? "text-white" : "hover:bg-white/60"
                }`
              }
              style={({ isActive }) => ({
                background: isActive ? "#6EC4E8" : "transparent",
                color: isActive ? "#fff" : "#2D3055",
              })}
            >
              <Icon size={18} /> {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t" style={{ borderColor: "#C7B5FF" }}>
          <p className="text-xs font-nunito mb-2" style={{ color: "#7E82A1" }}>Signed in as</p>
          <p className="font-fredoka text-sm mb-3" style={{ color: "#2D3055" }} data-testid="admin-user-name">
            {user?.name || user?.email}
          </p>
          <Link to="/" target="_blank" className="btn-ghost-warm w-full justify-center text-xs mb-2" data-testid="admin-view-site">
            View site <ExternalLink size={12} />
          </Link>
          <button onClick={handleLogout} className="btn-ghost-warm w-full justify-center text-xs" data-testid="admin-logout-btn">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="max-w-6xl mx-auto p-8 lg:p-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
